/**
 * P: Recommended flight price (no decimals, no ‘.’ or ‘,’ in the value, or NA)
 * Q: Cheapest price (no decimals, no ‘.’ or ‘,’ in the value)
 * @param {Itinerary} recommended
 * @param {Itinerary} cheapest
 * @returns {string}
 */
export default function getPriceLabel({ recommended, cheapest }) {
  const P = recommended?.price.amount;
  const Q = cheapest?.price.amount;
  return `pr:${P ? Math.floor(P) : 'NA'}-${Q ? Math.floor(Q) : 'NA'}`;
}
